//#region import
import React, { useEffect, useState } from 'react';
import GalleryShow from '../HomePage/components/GalleryShow';
import { FnAxios, FnDialog } from 'utilities/utilities';
//#endregion

const Gallery = () => {
    const [arrGallery, setGalleryData] = useState([]);
    const DialogFn = FnDialog();
    const AxiosFn = FnAxios();

    const onLoadData = () => {
        DialogFn.BlockUI();
        AxiosFn.Get("Home/GetHomeData", {}, (res) => {
            DialogFn.UnBlockUI();
            setGalleryData(res.lstGallery ?? [])
        }).then(
            () => {
                DialogFn.UnBlockUI();
            }
        );
    }
    useEffect(() => {
        onLoadData();
    }, []);

    return (
        <React.Fragment>
            <GalleryShow Gallery={arrGallery} IsPreview={false}/>
        </React.Fragment>
    )
}
export default Gallery;
